import React, { useEffect, useState } from "react";
import PageHelmet from "../component/common/Helmet";
import Breadcrumb from "../elements/common/Breadcrumb";
import ModalVideo from "react-modal-video";
import {
  FaTwitter,
  FaInstagram,
  FaFacebookF,
  FaLinkedinIn,
} from "react-icons/fa";
import ScrollToTop from "react-scroll-up";
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";
import controllers from "../controllers/projects";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Preloader from "../component/Preloader/Preloader";
import { useLoading } from "../LoadingContext";
import moment from "moment";
import YouTubeEmbed from "./YouTubeEmbed/YouTubeEmbed";


const ProjectDetails = () => {
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const postId = searchParams.get("id");
  const [data, setData] = useState(false);
  const { loading, setLoading } = useLoading();
  const { i18n } = useTranslation();
  const isEnglish = i18n.language === "en";

  useEffect(() => {
    setLoading(true);
    const getProjectDetails = () => {
      if (postId && postId != null) {
        return controllers
          .getProjectDetails(postId)
          .then((response) => {
            setData(response);
          })
          .catch((error) => {
            window.location.href = "/404";
          })
          .finally(() => {
            setTimeout(() => {
              setLoading(false); // set loading to false when data is fetched
            }, 4000);
          });
      } else {
        setLoading(false);
        window.location.href = "/404";
      }
    };
    setTimeout(() => {
      getProjectDetails();
    }, 800);
  }, [postId]);

  if (loading) {
    return <Preloader />;
  }

  return (
    <React.Fragment>

      <Header
        headertransparent="header--transparent"
        colorblack="color--black"
        logoname="logo.png"
      />

      {data && (
        <>
          <Breadcrumb
            parent={"Project Research"}
            title={isEnglish ? data.title.en : data.title.fr}
          />

         
          <div className="rn-project-details ptb--120 bg_color--1">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="project-details">
                    <div className="row row--35 mb--50">
                      <div className="col-lg-12">
                        <div className="inner">
                          <div className="section-title">
                            <h3 className="title">Project Summary :</h3>
                            <p className="description mt--30">
                              {isEnglish ? (
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: data.description.en,
                                  }}
                                  className=""
                                ></p>
                              ) : (
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: data.description.fr,
                                  }}
                                  className=""
                                ></p>
                              )}
                            </p>
                          </div>
                          <div className="project-view-list d-flex flex-wrap">
                            <div className="port-view">
                              <h4>Duration</h4>
                              <span>{data.duration}</span>
                            </div>

                            <div className="port-view">
                              <h4>Project Partners</h4>
                              <span>{data.partners}</span>
                            </div>

                            <div className="port-view">
                              <h4>Project status</h4>
                              <span>
                                {(data.status === "in_progress" &&
                                  "In Progress") ||
                                  (data.status === "completed" &&
                                    "Completed") ||
                                  (data.status === "not_started" &&
                                    "Not Started")}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="project-thumb-inner">
                      <div className="thumb position-relative mb--30">
                        <img
                          src={`${process.env.REACT_APP_DOMAIN}/api/projectsimages/${data.project_id}/${data.image}`}
                          alt="Project Images"
                          style={{ margin: "0 auto", display: "block" }}
                        />
                      </div>
                    </div>
                    <div className="project-thumb-inner">
                      <div className="thumb position-relative mb--30">
                        {data.video && (
                          <div className="YouTubeEmbed">
                            
                            <YouTubeEmbed url={data.video} />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
         
          <div className="backto-top">
            <ScrollToTop showUnder={160}>
              <FiChevronUp />
            </ScrollToTop>
          </div>
        </>
      )}

      <Footer />
    </React.Fragment>
  );
};
export default ProjectDetails;
